import styled, { css } from 'styled-components';

const mapBorder = (props) => {
  switch (props.buttonTypes) {
    case "FILLED":
      return css`
        border: 1px solid var(--palette-primary, #4611cf);

        &:disabled {
          border: 1px solid #d4d4d4;
        }
      `;
    case "BORDER":
      return css`
        border: 1px solid #d4d4d4;

        &:hover {
          border-color: ${props.isLoading ? "#d4d4d4" : "var(--palette-primary, #4611cf)"};
        }

        &:disabled {
          border: 1px solid #d4d4d4;
        }
      `;
    default:
      return css`
        border: none;
      `;
  }
};
const mapBgColor = (props) => {
  switch (props.buttonTypes) {
    case "FILLED":
      return css`
        background-color: var(--palette-primary, #4611cf);

        &:disabled {
          background-color: #fafafa;
        }
      `;
    case "BORDER":
      return css`
        background-color: transparent;

        &:disabled {
          background-color: #fafafa;
        }
      `;
    case "LINK":
      return css`
        background-color: transparent;
      `;
    default:
      return css`
        background-color: #ffffff;
      `;
  }
};
const mapColor = (props) => {
  switch (props.buttonTypes) {
    case "FILLED":
      return css`
        color: #ffffff;

        &:disabled {
          color: #d4d4d4;
        }
      `;
    case "BORDER":
      return css`
        color: #000000d9;

        &:hover {
          color: ${props.isLoading ? "#000000d9" : "var(--palette-primary, #4611cf)"};
        }

        &:disabled {
          color: #d4d4d4;
        }
      `;
    case "LINK":
      return css`
        color: #000000d9;

        &:disabled {
          color: #d4d4d4;
        }
      `;
    default:
      return css`
        color: #ffffff;

        &:disabled {
          color: #d4d4d4;
        }
      `;
  }
};
const mapShadowStyles = (props) => {
  switch (props.buttonTypes) {
    case "FILLED":
      return css`
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);

        &:hover {
          box-shadow: ${props.isLoading ? "1px 1px 2px rgba(0, 0, 0, 0.3)" : "1px 2px 4px rgba(0, 0, 0, 0.5)"};

          &:disabled {
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
          }
        }

        &:active {
          box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
        }
      `;
    case "BORDER":
      return css`
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);

        &:hover {
          box-shadow: ${props.isLoading ? "1px 1px 2px rgba(0, 0, 0, 0.1)" : "1px 2px 4px rgba(0, 0, 0, 0.2)"};

          &:disabled {
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
          }
        }

        &:active {
          box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
        }
      `;
    case "LINK":
    default:
      return css`
        box-shadow: none;

        &:hover {
          box-shadow: none;
        }

        &:active {
          box-shadow: none;
        }
      `;
  }
};
const mapFill = (props) => {
  switch (props.buttonTypes) {
    case "BORDER":
    case "LINK":
      return css`
        fill: #000000;
      `;
    default:
      return css`
        fill: #ffffff;
      `;
  }
};
const mapFillParent = (props) => {
  switch (props.buttonTypes) {
    case "BORDER":
      return css`
        &:hover .Button__loading__icon path {
          fill: ${props.isLoading ? "initial" : "var(--palette-primary, #4611cf)"};
        }
      `;
    default:
      return css``;
  }
};
const ButtonStyled = styled.button`
  align-items: center;
  outline: none;
  cursor: ${(props) => props.isLoading ? "default" : "pointer"};
  ${mapColor}
  ${mapBgColor};
  ${mapBorder};
  display: flex;
  justify-content: center;
  opacity: ${(props) => props.isLoading ? "0.6" : "1"};
  padding: 0.8rem 1.2em;
  transition: all 0.4s;
  ${mapShadowStyles}
  ${mapFillParent}
  font-family: inherit;

  &:disabled {
    cursor: default;
  }

  & > *:not(:first-child) {
    margin-left: 0.8rem;
  }

  .Button {
    &__wrapper {
      display: flex;

      & > *:not(:first-child) {
        margin-left: 0.8rem;
      }
    }

    &__loading {
      align-items: center;
      display: flex;
      animation: rotate 1s infinite;

      &__icon {
        height: 1.2em;
        width: 1.2em;

        path {
          ${mapFill}
        }
      }
    }
  }

  @keyframes rotate {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }
`;

export { ButtonStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
